import styled from "@emotion/styled";

import type * as auth from "@skilitics/auth-client";
import { ModalDialog } from "@skilitics/designer-ui-components";
import { useFormatMessage } from "@skilitics/localization";

import { PendingButtons } from "./PendingButtons.tsx";

export interface ConfirmCancelInviteDialogProps {
  invite: auth.WorkspaceInvite;
  confirm: () => Promise<void>;
  close: () => void;
}

export const ConfirmCancelInviteDialog = ({ invite, confirm, close }: ConfirmCancelInviteDialogProps) => {
  const formatMessage = useFormatMessage(formatStrings);

  return (
    <ModalDialog
      open
      maxWidth="xs"
      header={formatMessage("header")}
      buttons={
        <PendingButtons
          confirmLabel={formatMessage("confirmLabel")}
          cancelLabel={formatMessage("cancelLabel")}
          confirm={confirm}
          close={close}
        />
      }
    >
      <Content>
        <p>{formatMessage("message", { email: invite.email })}</p>
      </Content>
    </ModalDialog>
  );
};

const Content = styled.div`
  font-size: 14px;
  white-space: pre-wrap;
  padding: 8px;

  p {
    margin: 0;
  }
`;

const formatStrings = {
  header: {
    en: "Cancel Workspace Invite?",
  },
  message: {
    en:
      "Are you sure you want to cancel the invitation sent to {email}?\n" +
      "\n" +
      "They will already have their invitation message, but will not be able to claim the link when following it.",
  },
  confirmLabel: {
    en: "Yes, cancel",
  },
  cancelLabel: {
    en: "No, keep it",
  },
};
